import React from 'react';

const ROLE_COLORS = {
  superadmin: { background: '#7B1FA2', color: '#fff' },
  admin:      { background: '#C73B33', color: '#fff' },
  readonly:   { background: '#1976D2', color: '#fff' },
  member:     { background: '#388E3C', color: '#fff' },
};

const RoleBadge = ({ role }) => (
  <span style={{
    ...ROLE_COLORS[role],
    padding: '3px 10px',
    borderRadius: '12px',
    fontSize: '0.78rem',
    fontWeight: 600,
    textTransform: 'capitalize',
  }}>
    {role}
  </span>
);

const ProviderBadge = ({ provider }) => (
  <span style={{
    background: provider === 'google' ? '#4285F4' : '#757575',
    color: '#fff',
    padding: '3px 10px',
    borderRadius: '12px',
    fontSize: '0.78rem',
    fontWeight: 500,
    display: 'inline-block',
    whiteSpace: 'nowrap',
  }}>
    {provider === 'google' ? '🔵 Google' : '🔑 Local'}
  </span>
);

const UsersTable = ({ users, onEdit, onDelete }) => {
  if (users.length === 0) {
    return (
      <p style={{ textAlign: 'center', color: '#888', marginTop: '30px' }}>
        No hay usuarios registrados.
      </p>
    );
  }

  return (
    <div style={{ overflowX: 'auto' }}>
      <table className="table table-striped table-bordered table-hover">
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Email</th>
            <th>DNI</th>
            <th>Teléfono</th>
            <th>Rol</th>
            <th>Auth</th>
            <th>Estado</th>
            <th>Registrado</th>
            <th style={{ textAlign: 'center' }}>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user) => (
            <tr key={user.id} style={{ opacity: user.is_active ? 1 : 0.5 }}>
              <td>{user.display_name}</td>
              <td>{user.email}</td>
              <td>{user.dni || <span style={{ color: '#aaa' }}>—</span>}</td>
              <td>{user.phone || <span style={{ color: '#aaa' }}>—</span>}</td>
              <td><RoleBadge role={user.role} /></td>
              <td><ProviderBadge provider={user.auth_provider} /></td>
              <td>
                <span style={{ color: user.is_active ? '#388E3C' : '#C73B33', fontWeight: 600 }}>
                  {user.is_active ? '✓ Activo' : '✗ Inactivo'}
                </span>
              </td>
              <td style={{ whiteSpace: 'nowrap' }}>
                {new Date(user.created_at).toLocaleDateString('es-AR')}
              </td>
              <td style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>
                <button
                  className="btn btn-sm"
                  style={{ backgroundColor: '#1976D2', color: '#fff', marginRight: '6px' }}
                  onClick={() => onEdit(user)}
                >
                  Editar
                </button>
                <button
                  className="btn btn-sm"
                  style={{ backgroundColor: '#C73B33', color: '#fff' }}
                  onClick={() => onDelete(user)}
                >
                  Eliminar
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default UsersTable;
